import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.scss']
})
export class WebsiteComponent {
  @Input() feature: any;
  @Output() featureChange = new EventEmitter<any>();

  onInputChange(newValue: string) {
    this.feature.value = newValue;
    this.featureChange.emit(this.feature);
  }

  isValidUrl(url: string): boolean {
    if (!url) return true; // Allow empty input
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }
}